import { Country } from '../modules/countries'

export const COUNTRY_EU_CODES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'HR',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'CZ',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'HU',
]

export const COUNTRIES_LIST: Country[] = [
  {
    alpha3Code: 'ICS',
    alpha2Code: 'IC',
    name: 'Canary Islands',
  },
  {
    alpha3Code: 'DOM',
    alpha2Code: 'DO',
    name: 'Dominican Republic',
  },
  {
    alpha3Code: 'GUY',
    alpha2Code: 'GY',
    name: 'Guyana',
  },
  {
    alpha3Code: 'NOR',
    alpha2Code: 'NO',
    name: 'Norway',
  },
  {
    alpha3Code: 'ARE',
    alpha2Code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    alpha3Code: 'AZE',
    alpha2Code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    alpha3Code: 'EST',
    alpha2Code: 'EE',
    name: 'Estonia',
  },
  {
    alpha3Code: 'GNB',
    alpha2Code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    alpha3Code: 'AGO',
    alpha2Code: 'AO',
    name: 'Angola',
  },
  {
    alpha3Code: 'BRN',
    alpha2Code: 'BN',
    name: 'Brunei',
  },
  {
    alpha3Code: 'ITA',
    alpha2Code: 'IT',
    name: 'Italy',
    provinces: [
      {
        code: 'AG',
        name: 'Agrigento',
        region: 'Sicilia',
      },
      {
        code: 'AL',
        name: 'Alessandria',
        region: 'Piemonte',
      },
      {
        code: 'AN',
        name: 'Ancona',
        region: 'Marche',
      },
      {
        code: 'AR',
        name: 'Arezzo',
        region: 'Toscana',
      },
      {
        code: 'AP',
        name: 'Ascoli Piceno',
        region: 'Marche',
      },
      {
        code: 'AT',
        name: 'Asti',
        region: 'Piemonte',
      },
      {
        code: 'AV',
        name: 'Avellino',
        region: 'Campania',
      },
      {
        code: 'BA',
        name: 'Bari',
        region: 'Puglia',
      },
      {
        code: 'BT',
        name: 'Barletta-Andria-Trani',
        region: 'Puglia',
      },
      {
        code: 'BL',
        name: 'Belluno',
        region: 'Veneto',
      },
      {
        code: 'BN',
        name: 'Benevento',
        region: 'Campania',
      },
      {
        code: 'BG',
        name: 'Bergamo',
        region: 'Lombardia',
      },
      {
        code: 'BI',
        name: 'Biella',
        region: 'Piemonte',
      },
      {
        code: 'BO',
        name: 'Bologna',
        region: 'Emilia Romagna',
      },
      {
        code: 'BZ',
        name: 'Bolzano',
        region: 'Trentino Alto Adige',
      },
      {
        code: 'BS',
        name: 'Brescia',
        region: 'Lombardia',
      },
      {
        code: 'BR',
        name: 'Brindisi',
        region: 'Puglia',
      },
      {
        code: 'CA',
        name: 'Cagliari',
        region: 'Sardegna',
      },
      {
        code: 'CL',
        name: 'Caltanissetta',
        region: 'Sicilia',
      },
      {
        code: 'CB',
        name: 'Campobasso',
        region: 'Molise',
      },
      {
        code: 'CE',
        name: 'Caserta',
        region: 'Campania',
      },
      {
        code: 'CT',
        name: 'Catania',
        region: 'Sicilia',
      },
      {
        code: 'CZ',
        name: 'Catanzaro',
        region: 'Calabria',
      },
      {
        code: 'CH',
        name: 'Chieti',
        region: 'Abruzzo',
      },
      {
        code: 'CO',
        name: 'Como',
        region: 'Lombardia',
      },
      {
        code: 'CS',
        name: 'Cosenza',
        region: 'Calabria',
      },
      {
        code: 'CR',
        name: 'Cremona',
        region: 'Lombardia',
      },
      {
        code: 'KR',
        name: 'Crotone',
        region: 'Calabria',
      },
      {
        code: 'CN',
        name: 'Cuneo',
        region: 'Piemonte',
      },
      {
        code: 'EN',
        name: 'Enna',
        region: 'Sicilia',
      },
      {
        code: 'FM',
        name: 'Fermo',
        region: 'Marche',
      },
      {
        code: 'FE',
        name: 'Ferrara',
        region: 'Emilia Romagna',
      },
      {
        code: 'FI',
        name: 'Firenze',
        region: 'Toscana',
      },
      {
        code: 'FG',
        name: 'Foggia',
        region: 'Puglia',
      },
      {
        code: 'FC',
        name: 'Forlì-Cesena',
        region: 'Emilia Romagna',
      },
      {
        code: 'FR',
        name: 'Frosinone',
        region: 'Lazio',
      },
      {
        code: 'GE',
        name: 'Genova',
        region: 'Liguria',
      },
      {
        code: 'GO',
        name: 'Gorizia',
        region: 'Friuli Venezia Giulia',
      },
      {
        code: 'GR',
        name: 'Grosseto',
        region: 'Toscana',
      },
      {
        code: 'IM',
        name: 'Imperia',
        region: 'Liguria',
      },
      {
        code: 'IS',
        name: 'Isernia',
        region: 'Molise',
      },
      {
        code: 'AQ',
        name: "L'Aquila",
        region: 'Abruzzo',
      },
      {
        code: 'SP',
        name: 'La Spezia',
        region: 'Liguria',
      },
      {
        code: 'LT',
        name: 'Latina',
        region: 'Lazio',
      },
      {
        code: 'LE',
        name: 'Lecce',
        region: 'Puglia',
      },
      {
        code: 'LC',
        name: 'Lecco',
        region: 'Lombardia',
      },
      {
        code: 'LI',
        name: 'Livorno',
        region: 'Toscana',
      },
      {
        code: 'LO',
        name: 'Lodi',
        region: 'Lombardia',
      },
      {
        code: 'LU',
        name: 'Lucca',
        region: 'Toscana',
      },
      {
        code: 'MC',
        name: 'Macerata',
        region: 'Marche',
      },
      {
        code: 'MN',
        name: 'Mantova',
        region: 'Lombardia',
      },
      {
        code: 'MS',
        name: 'Massa-Carrara',
        region: 'Toscana',
      },
      {
        code: 'MT',
        name: 'Matera',
        region: 'Basilicata',
      },
      {
        code: 'ME',
        name: 'Messina',
        region: 'Sicilia',
      },
      {
        code: 'MI',
        name: 'Milano',
        region: 'Lombardia',
      },
      {
        code: 'MO',
        name: 'Modena',
        region: 'Emilia Romagna',
      },
      {
        code: 'MB',
        name: 'Monza e della Brianza',
        region: 'Lombardia',
      },
      {
        code: 'NA',
        name: 'Napoli',
        region: 'Campania',
      },
      {
        code: 'NO',
        name: 'Novara',
        region: 'Piemonte',
      },
      {
        code: 'NU',
        name: 'Nuoro',
        region: 'Sardegna',
      },
      {
        code: 'OR',
        name: 'Oristano',
        region: 'Sardegna',
      },
      {
        code: 'PD',
        name: 'Padova',
        region: 'Veneto',
      },
      {
        code: 'PA',
        name: 'Palermo',
        region: 'Sicilia',
      },
      {
        code: 'PR',
        name: 'Parma',
        region: 'Emilia Romagna',
      },
      {
        code: 'PV',
        name: 'Pavia',
        region: 'Lombardia',
      },
      {
        code: 'PG',
        name: 'Perugia',
        region: 'Umbria',
      },
      {
        code: 'PU',
        name: 'Pesaro e Urbino',
        region: 'Marche',
      },
      {
        code: 'PE',
        name: 'Pescara',
        region: 'Abruzzo',
      },
      {
        code: 'PC',
        name: 'Piacenza',
        region: 'Emilia Romagna',
      },
      {
        code: 'PI',
        name: 'Pisa',
        region: 'Toscana',
      },
      {
        code: 'PT',
        name: 'Pistoia',
        region: 'Toscana',
      },
      {
        code: 'PN',
        name: 'Pordenone',
        region: 'Friuli Venezia Giulia',
      },
      {
        code: 'PZ',
        name: 'Potenza',
        region: 'Basilicata',
      },
      {
        code: 'PO',
        name: 'Prato',
        region: 'Toscana',
      },
      {
        code: 'RG',
        name: 'Ragusa',
        region: 'Sicilia',
      },
      {
        code: 'RA',
        name: 'Ravenna',
        region: 'Emilia Romagna',
      },
      {
        code: 'RC',
        name: 'Reggio Calabria',
        region: 'Calabria',
      },
      {
        code: 'RE',
        name: "Reggio nell'Emilia",
        region: 'Emilia Romagna',
      },
      {
        code: 'RI',
        name: 'Rieti',
        region: 'Lazio',
      },
      {
        code: 'RN',
        name: 'Rimini',
        region: 'Emilia Romagna',
      },
      {
        code: 'RM',
        name: 'Roma',
        region: 'Lazio',
      },
      {
        code: 'RO',
        name: 'Rovigo',
        region: 'Veneto',
      },
      {
        code: 'SA',
        name: 'Salerno',
        region: 'Campania',
      },
      {
        code: 'SS',
        name: 'Sassari',
        region: 'Sardegna',
      },
      {
        code: 'SV',
        name: 'Savona',
        region: 'Liguria',
      },
      {
        code: 'SI',
        name: 'Siena',
        region: 'Toscana',
      },
      {
        code: 'SR',
        name: 'Siracusa',
        region: 'Sicilia',
      },
      {
        code: 'SO',
        name: 'Sondrio',
        region: 'Lombardia',
      },
      {
        code: 'SU',
        name: 'Sud Sardegna (soppressa)',
        region: 'Sardegna',
      },
      {
        code: 'TA',
        name: 'Taranto',
        region: 'Puglia',
      },
      {
        code: 'TE',
        name: 'Teramo',
        region: 'Abruzzo',
      },
      {
        code: 'TR',
        name: 'Terni',
        region: 'Umbria',
      },
      {
        code: 'TO',
        name: 'Torino',
        region: 'Piemonte',
      },
      {
        code: 'TP',
        name: 'Trapani',
        region: 'Sicilia',
      },
      {
        code: 'TN',
        name: 'Trento',
        region: 'Trentino Alto Adige',
      },
      {
        code: 'TV',
        name: 'Treviso',
        region: 'Veneto',
      },
      {
        code: 'TS',
        name: 'Trieste',
        region: 'Friuli Venezia Giulia',
      },
      {
        code: 'UD',
        name: 'Udine',
        region: 'Friuli Venezia Giulia',
      },
      {
        code: 'AO',
        name: "Valle d'Aosta",
        region: "Valle d'Aosta",
      },
      {
        code: 'VA',
        name: 'Varese',
        region: 'Lombardia',
      },
      {
        code: 'VE',
        name: 'Venezia',
        region: 'Veneto',
      },
      {
        code: 'VB',
        name: 'Verbano-Cusio-Ossola',
        region: 'Piemonte',
      },
      {
        code: 'VC',
        name: 'Vercelli',
        region: 'Piemonte',
      },
      {
        code: 'VR',
        name: 'Verona',
        region: 'Veneto',
      },
      {
        code: 'VV',
        name: 'Vibo Valentia',
        region: 'Calabria',
      },
      {
        code: 'VI',
        name: 'Vicenza',
        region: 'Veneto',
      },
      {
        code: 'VT',
        name: 'Viterbo',
        region: 'Lazio',
      },
      {
        name: 'Gallura Nord-Est Sardegna',
        code: 'OT',
        region: 'Sardegna',
      },
      {
        name: 'Medio Campidano',
        code: 'VS',
        region: 'Sardegna',
      },
      {
        name: 'Sulcis Iglesiente',
        code: 'CI',
        region: 'Sardegna',
      },
      {
        name: 'Ogliastra',
        code: 'OG',
        region: 'Sardegna',
      },
    ],
  },
  {
    alpha3Code: 'VGB',
    alpha2Code: 'VG',
    name: 'British Virgin Islands',
  },
  {
    alpha3Code: 'CZE',
    alpha2Code: 'CZ',
    name: 'Czechia',
  },
  {
    alpha3Code: 'MYT',
    alpha2Code: 'YT',
    name: 'Mayotte',
  },
  {
    alpha3Code: 'NIC',
    alpha2Code: 'NI',
    name: 'Nicaragua',
  },
  {
    alpha3Code: 'PRK',
    alpha2Code: 'KP',
    name: 'North Korea',
  },
  {
    alpha3Code: 'SYR',
    alpha2Code: 'SY',
    name: 'Syria',
  },
  {
    alpha3Code: 'BHR',
    alpha2Code: 'BH',
    name: 'Bahrain',
  },
  {
    alpha3Code: 'MTQ',
    alpha2Code: 'MQ',
    name: 'Martinique',
  },
  {
    alpha3Code: 'ALB',
    alpha2Code: 'AL',
    name: 'Albania',
  },
  {
    alpha3Code: 'KIR',
    alpha2Code: 'KI',
    name: 'Kiribati',
  },
  {
    alpha3Code: 'MOZ',
    alpha2Code: 'MZ',
    name: 'Mozambique',
  },
  {
    alpha3Code: 'ASM',
    alpha2Code: 'AS',
    name: 'American Samoa',
  },
  {
    alpha3Code: 'PHL',
    alpha2Code: 'PH',
    name: 'Philippines',
  },
  {
    alpha3Code: 'LTU',
    alpha2Code: 'LT',
    name: 'Lithuania',
  },
  {
    alpha3Code: 'PCN',
    alpha2Code: 'PN',
    name: 'Pitcairn Islands',
  },
  {
    alpha3Code: 'COL',
    alpha2Code: 'CO',
    name: 'Colombia',
  },
  {
    alpha3Code: 'SYC',
    alpha2Code: 'SC',
    name: 'Seychelles',
  },
  {
    alpha3Code: 'BOL',
    alpha2Code: 'BO',
    name: 'Bolivia',
  },
  {
    alpha3Code: 'MLT',
    alpha2Code: 'MT',
    name: 'Malta',
  },
  {
    alpha3Code: 'GRC',
    alpha2Code: 'GR',
    name: 'Greece',
  },
  {
    alpha3Code: 'LCA',
    alpha2Code: 'LC',
    name: 'Saint Lucia',
  },
  {
    alpha3Code: 'KAZ',
    alpha2Code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    alpha3Code: 'BIH',
    alpha2Code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    alpha3Code: 'FJI',
    alpha2Code: 'FJ',
    name: 'Fiji',
  },
  {
    alpha3Code: 'MNE',
    alpha2Code: 'ME',
    name: 'Montenegro',
  },
  {
    alpha3Code: 'SAU',
    alpha2Code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    alpha3Code: 'SGS',
    alpha2Code: 'GS',
    name: 'South Georgia',
  },
  {
    alpha3Code: 'SWZ',
    alpha2Code: 'SZ',
    name: 'Eswatini',
  },
  {
    alpha3Code: 'COM',
    alpha2Code: 'KM',
    name: 'Comoros',
  },
  {
    alpha3Code: 'MSR',
    alpha2Code: 'MS',
    name: 'Montserrat',
  },
  {
    alpha3Code: 'NIU',
    alpha2Code: 'NU',
    name: 'Niue',
  },
  {
    alpha3Code: 'VIR',
    alpha2Code: 'VI',
    name: 'United States Virgin Islands',
  },
  {
    alpha3Code: 'GTM',
    alpha2Code: 'GT',
    name: 'Guatemala',
  },
  {
    alpha3Code: 'PLW',
    alpha2Code: 'PW',
    name: 'Palau',
  },
  {
    alpha3Code: 'GBR',
    alpha2Code: 'GB',
    name: 'United Kingdom',
  },
  {
    alpha3Code: 'DNK',
    alpha2Code: 'DK',
    name: 'Denmark',
  },
  {
    alpha3Code: 'DJI',
    alpha2Code: 'DJ',
    name: 'Djibouti',
  },
  {
    alpha3Code: 'ISR',
    alpha2Code: 'IL',
    name: 'Israel',
  },
  {
    alpha3Code: 'TKM',
    alpha2Code: 'TM',
    name: 'Turkmenistan',
  },
  {
    alpha3Code: 'FSM',
    alpha2Code: 'FM',
    name: 'Micronesia',
  },
  {
    alpha3Code: 'UKR',
    alpha2Code: 'UA',
    name: 'Ukraine',
  },
  {
    alpha3Code: 'SLB',
    alpha2Code: 'SB',
    name: 'Solomon Islands',
  },
  {
    alpha3Code: 'HND',
    alpha2Code: 'HN',
    name: 'Honduras',
  },
  {
    alpha3Code: 'CXR',
    alpha2Code: 'CX',
    name: 'Christmas Island',
  },
  {
    alpha3Code: 'SJM',
    alpha2Code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    alpha3Code: 'TJK',
    alpha2Code: 'TJ',
    name: 'Tajikistan',
  },
  {
    alpha3Code: 'CYM',
    alpha2Code: 'KY',
    name: 'Cayman Islands',
  },
  {
    alpha3Code: 'IRQ',
    alpha2Code: 'IQ',
    name: 'Iraq',
  },
  {
    alpha3Code: 'UGA',
    alpha2Code: 'UG',
    name: 'Uganda',
  },
  {
    alpha3Code: 'RUS',
    alpha2Code: 'RU',
    name: 'Russia',
  },
  {
    alpha3Code: 'ZWE',
    alpha2Code: 'ZW',
    name: 'Zimbabwe',
  },
  {
    alpha3Code: 'SDN',
    alpha2Code: 'SD',
    name: 'Sudan',
  },
  {
    alpha3Code: 'TCA',
    alpha2Code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    alpha3Code: 'HTI',
    alpha2Code: 'HT',
    name: 'Haiti',
  },
  {
    alpha3Code: 'SWE',
    alpha2Code: 'SE',
    name: 'Sweden',
  },
  {
    alpha3Code: 'LAO',
    alpha2Code: 'LA',
    name: 'Laos',
  },
  {
    alpha3Code: 'AND',
    alpha2Code: 'AD',
    name: 'Andorra',
  },
  {
    alpha3Code: 'TUR',
    alpha2Code: 'TR',
    name: 'Turkey',
  },
  {
    alpha3Code: 'LSO',
    alpha2Code: 'LS',
    name: 'Lesotho',
  },
  {
    alpha3Code: 'AIA',
    alpha2Code: 'AI',
    name: 'Anguilla',
  },
  {
    alpha3Code: 'SVK',
    alpha2Code: 'SK',
    name: 'Slovakia',
  },
  {
    alpha3Code: 'GHA',
    alpha2Code: 'GH',
    name: 'Ghana',
  },
  {
    alpha3Code: 'FIN',
    alpha2Code: 'FI',
    name: 'Finland',
  },
  {
    alpha3Code: 'MAR',
    alpha2Code: 'MA',
    name: 'Morocco',
  },
  {
    alpha3Code: 'NER',
    alpha2Code: 'NE',
    name: 'Niger',
  },
  {
    alpha3Code: 'URY',
    alpha2Code: 'UY',
    name: 'Uruguay',
  },
  {
    alpha3Code: 'CHL',
    alpha2Code: 'CL',
    name: 'Chile',
  },
  {
    alpha3Code: 'BRB',
    alpha2Code: 'BB',
    name: 'Barbados',
  },
  {
    alpha3Code: 'KHM',
    alpha2Code: 'KH',
    name: 'Cambodia',
  },
  {
    alpha3Code: 'BFA',
    alpha2Code: 'BF',
    name: 'Burkina Faso',
  },
  {
    alpha3Code: 'RWA',
    alpha2Code: 'RW',
    name: 'Rwanda',
  },
  {
    alpha3Code: 'TTO',
    alpha2Code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    alpha3Code: 'STP',
    alpha2Code: 'ST',
    name: 'São Tomé and Príncipe',
  },
  {
    alpha3Code: 'BGD',
    alpha2Code: 'BD',
    name: 'Bangladesh',
  },
  {
    alpha3Code: 'IND',
    alpha2Code: 'IN',
    name: 'India',
  },
  {
    alpha3Code: 'COG',
    alpha2Code: 'CG',
    name: 'Republic of the Congo',
  },
  {
    alpha3Code: 'OMN',
    alpha2Code: 'OM',
    name: 'Oman',
  },
  {
    alpha3Code: 'PRY',
    alpha2Code: 'PY',
    name: 'Paraguay',
  },
  {
    alpha3Code: 'TGO',
    alpha2Code: 'TG',
    name: 'Togo',
  },
  {
    alpha3Code: 'BGR',
    alpha2Code: 'BG',
    name: 'Bulgaria',
  },
  {
    alpha3Code: 'SLV',
    alpha2Code: 'SV',
    name: 'El Salvador',
  },
  {
    alpha3Code: 'FRO',
    alpha2Code: 'FO',
    name: 'Faroe Islands',
  },
  {
    alpha3Code: 'BWA',
    alpha2Code: 'BW',
    name: 'Botswana',
  },
  {
    alpha3Code: 'PYF',
    alpha2Code: 'PF',
    name: 'French Polynesia',
  },
  {
    alpha3Code: 'PRT',
    alpha2Code: 'PT',
    name: 'Portugal',
  },
  {
    alpha3Code: 'VEN',
    alpha2Code: 'VE',
    name: 'Venezuela',
  },
  {
    alpha3Code: 'FRA',
    alpha2Code: 'FR',
    name: 'France',
  },
  {
    alpha3Code: 'PNG',
    alpha2Code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    alpha3Code: 'TWN',
    alpha2Code: 'TW',
    name: 'Taiwan',
  },
  {
    alpha3Code: 'MDA',
    alpha2Code: 'MD',
    name: 'Moldova',
  },
  {
    alpha3Code: 'CIV',
    alpha2Code: 'CI',
    name: 'Ivory Coast',
  },
  {
    alpha3Code: 'BLM',
    alpha2Code: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    alpha3Code: 'BRA',
    alpha2Code: 'BR',
    name: 'Brazil',
  },
  {
    alpha3Code: 'LBN',
    alpha2Code: 'LB',
    name: 'Lebanon',
  },
  {
    alpha3Code: 'YEM',
    alpha2Code: 'YE',
    name: 'Yemen',
  },
  {
    alpha3Code: 'CUW',
    alpha2Code: 'CW',
    name: 'Curaçao',
  },
  {
    alpha3Code: 'GMB',
    alpha2Code: 'GM',
    name: 'Gambia',
  },
  {
    alpha3Code: 'WLF',
    alpha2Code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    alpha3Code: 'ETH',
    alpha2Code: 'ET',
    name: 'Ethiopia',
  },
  {
    alpha3Code: 'LKA',
    alpha2Code: 'LK',
    name: 'Sri Lanka',
  },
  {
    alpha3Code: 'CMR',
    alpha2Code: 'CM',
    name: 'Cameroon',
  },
  {
    alpha3Code: 'GGY',
    alpha2Code: 'GG',
    name: 'Guernsey',
  },
  {
    alpha3Code: 'CAF',
    alpha2Code: 'CF',
    name: 'Central African Republic',
  },
  {
    alpha3Code: 'GUF',
    alpha2Code: 'GF',
    name: 'French Guiana',
  },
  {
    alpha3Code: 'ABW',
    alpha2Code: 'AW',
    name: 'Aruba',
  },
  {
    alpha3Code: 'ATF',
    alpha2Code: 'TF',
    name: 'French Southern and Antarctic Lands',
  },
  {
    alpha3Code: 'DZA',
    alpha2Code: 'DZ',
    name: 'Algeria',
  },
  {
    alpha3Code: 'MCO',
    alpha2Code: 'MC',
    name: 'Monaco',
  },
  {
    alpha3Code: 'ARM',
    alpha2Code: 'AM',
    name: 'Armenia',
  },
  {
    alpha3Code: 'CHE',
    alpha2Code: 'CH',
    name: 'Switzerland',
  },
  {
    alpha3Code: 'PER',
    alpha2Code: 'PE',
    name: 'Peru',
  },
  {
    alpha3Code: 'IRN',
    alpha2Code: 'IR',
    name: 'Iran',
  },
  {
    alpha3Code: 'SHN',
    alpha2Code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    alpha3Code: 'SEN',
    alpha2Code: 'SN',
    name: 'Senegal',
  },
  {
    alpha3Code: 'SPM',
    alpha2Code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    alpha3Code: 'VCT',
    alpha2Code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    alpha3Code: 'ZMB',
    alpha2Code: 'ZM',
    name: 'Zambia',
  },
  {
    alpha3Code: 'SOM',
    alpha2Code: 'SO',
    name: 'Somalia',
  },
  {
    alpha3Code: 'AUT',
    alpha2Code: 'AT',
    name: 'Austria',
  },
  {
    alpha3Code: 'TON',
    alpha2Code: 'TO',
    name: 'Tonga',
  },
  {
    alpha3Code: 'CPV',
    alpha2Code: 'CV',
    name: 'Cape Verde',
  },
  {
    alpha3Code: 'THA',
    alpha2Code: 'TH',
    name: 'Thailand',
  },
  {
    alpha3Code: 'ESH',
    alpha2Code: 'EH',
    name: 'Western Sahara',
  },
  {
    alpha3Code: 'TLS',
    alpha2Code: 'TL',
    name: 'Timor-Leste',
  },
  {
    alpha3Code: 'ZAF',
    alpha2Code: 'ZA',
    name: 'South Africa',
  },
  {
    alpha3Code: 'GNQ',
    alpha2Code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    alpha3Code: 'GIB',
    alpha2Code: 'GI',
    name: 'Gibraltar',
  },
  {
    alpha3Code: 'BEN',
    alpha2Code: 'BJ',
    name: 'Benin',
  },
  {
    alpha3Code: 'MAC',
    alpha2Code: 'MO',
    name: 'Macau',
  },
  {
    alpha3Code: 'MWI',
    alpha2Code: 'MW',
    name: 'Malawi',
  },
  {
    alpha3Code: 'AUS',
    alpha2Code: 'AU',
    name: 'Australia',
  },
  {
    alpha3Code: 'JAM',
    alpha2Code: 'JM',
    name: 'Jamaica',
  },
  {
    alpha3Code: 'TCD',
    alpha2Code: 'TD',
    name: 'Chad',
  },
  {
    alpha3Code: 'MMR',
    alpha2Code: 'MM',
    name: 'Myanmar',
  },
  {
    alpha3Code: 'NGA',
    alpha2Code: 'NG',
    name: 'Nigeria',
  },
  {
    alpha3Code: 'MRT',
    alpha2Code: 'MR',
    name: 'Mauritania',
  },
  {
    alpha3Code: 'BMU',
    alpha2Code: 'BM',
    name: 'Bermuda',
  },
  {
    alpha3Code: 'ECU',
    alpha2Code: 'EC',
    name: 'Ecuador',
  },
  {
    alpha3Code: 'MUS',
    alpha2Code: 'MU',
    name: 'Mauritius',
  },
  {
    alpha3Code: 'GRL',
    alpha2Code: 'GL',
    name: 'Greenland',
  },
  {
    alpha3Code: 'NCL',
    alpha2Code: 'NC',
    name: 'New Caledonia',
  },
  {
    alpha3Code: 'NZL',
    alpha2Code: 'NZ',
    name: 'New Zealand',
  },
  {
    alpha3Code: 'ARG',
    alpha2Code: 'AR',
    name: 'Argentina',
  },
  {
    alpha3Code: 'CRI',
    alpha2Code: 'CR',
    name: 'Costa Rica',
  },
  {
    alpha3Code: 'MKD',
    alpha2Code: 'MK',
    name: 'North Macedonia',
  },
  {
    alpha3Code: 'MHL',
    alpha2Code: 'MH',
    name: 'Marshall Islands',
  },
  {
    alpha3Code: 'MLI',
    alpha2Code: 'ML',
    name: 'Mali',
  },
  {
    alpha3Code: 'BLZ',
    alpha2Code: 'BZ',
    name: 'Belize',
  },
  {
    alpha3Code: 'KEN',
    alpha2Code: 'KE',
    name: 'Kenya',
  },
  {
    alpha3Code: 'ALA',
    alpha2Code: 'AX',
    name: 'Åland Islands',
  },
  {
    alpha3Code: 'JOR',
    alpha2Code: 'JO',
    name: 'Jordan',
  },
  {
    alpha3Code: 'MDG',
    alpha2Code: 'MG',
    name: 'Madagascar',
  },
  {
    alpha3Code: 'VAT',
    alpha2Code: 'VA',
    name: 'Vatican City',
  },
  {
    alpha3Code: 'IDN',
    alpha2Code: 'ID',
    name: 'Indonesia',
  },
  {
    alpha3Code: 'ISL',
    alpha2Code: 'IS',
    name: 'Iceland',
  },
  {
    alpha3Code: 'BES',
    alpha2Code: 'BQ',
    name: 'Caribbean Netherlands',
  },
  {
    alpha3Code: 'SGP',
    alpha2Code: 'SG',
    name: 'Singapore',
  },
  {
    alpha3Code: 'MYS',
    alpha2Code: 'MY',
    name: 'Malaysia',
  },
  {
    alpha3Code: 'MEX',
    alpha2Code: 'MX',
    name: 'Mexico',
  },
  {
    alpha3Code: 'NAM',
    alpha2Code: 'NA',
    name: 'Namibia',
  },
  {
    alpha3Code: 'PRI',
    alpha2Code: 'PR',
    name: 'Puerto Rico',
  },
  {
    alpha3Code: 'AFG',
    alpha2Code: 'AF',
    name: 'Afghanistan',
  },
  {
    alpha3Code: 'BLR',
    alpha2Code: 'BY',
    name: 'Belarus',
  },
  {
    alpha3Code: 'SXM',
    alpha2Code: 'SX',
    name: 'Sint Maarten',
  },
  {
    alpha3Code: 'TZA',
    alpha2Code: 'TZ',
    name: 'Tanzania',
  },
  {
    alpha3Code: 'IMN',
    alpha2Code: 'IM',
    name: 'Isle of Man',
  },
  {
    alpha3Code: 'GEO',
    alpha2Code: 'GE',
    name: 'Georgia',
  },
  {
    alpha3Code: 'HRV',
    alpha2Code: 'HR',
    name: 'Croatia',
  },
  {
    alpha3Code: 'PAK',
    alpha2Code: 'PK',
    name: 'Pakistan',
  },
  {
    alpha3Code: 'KWT',
    alpha2Code: 'KW',
    name: 'Kuwait',
  },
  {
    alpha3Code: 'ESP',
    alpha2Code: 'ES',
    name: 'Spain',
  },
  {
    alpha3Code: 'LIE',
    alpha2Code: 'LI',
    name: 'Liechtenstein',
  },
  {
    alpha3Code: 'PAN',
    alpha2Code: 'PA',
    name: 'Panama',
  },
  {
    alpha3Code: 'ATG',
    alpha2Code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    alpha3Code: 'JPN',
    alpha2Code: 'JP',
    name: 'Japan',
  },
  {
    alpha3Code: 'COD',
    alpha2Code: 'CD',
    name: 'DR Congo',
  },
  {
    alpha3Code: 'CHN',
    alpha2Code: 'CN',
    name: 'China',
  },
  {
    alpha3Code: 'GLP',
    alpha2Code: 'GP',
    name: 'Guadeloupe',
  },
  {
    alpha3Code: 'LBY',
    alpha2Code: 'LY',
    name: 'Libya',
  },
  {
    alpha3Code: 'ROU',
    alpha2Code: 'RO',
    name: 'Romania',
  },
  {
    alpha3Code: 'IRL',
    alpha2Code: 'IE',
    name: 'Ireland',
  },
  {
    alpha3Code: 'EGY',
    alpha2Code: 'EG',
    name: 'Egypt',
  },
  {
    alpha3Code: 'IOT',
    alpha2Code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    alpha3Code: 'MAF',
    alpha2Code: 'MF',
    name: 'Saint Martin',
  },
  {
    alpha3Code: 'NFK',
    alpha2Code: 'NF',
    name: 'Norfolk Island',
  },
  {
    alpha3Code: 'VNM',
    alpha2Code: 'VN',
    name: 'Vietnam',
  },
  {
    alpha3Code: 'LVA',
    alpha2Code: 'LV',
    name: 'Latvia',
  },
  {
    alpha3Code: 'TUN',
    alpha2Code: 'TN',
    name: 'Tunisia',
  },
  {
    alpha3Code: 'DEU',
    alpha2Code: 'DE',
    name: 'Germany',
  },
  {
    alpha3Code: 'ATA',
    alpha2Code: 'AQ',
    name: 'Antarctica',
  },
  {
    alpha3Code: 'WSM',
    alpha2Code: 'WS',
    name: 'Samoa',
  },
  {
    alpha3Code: 'HKG',
    alpha2Code: 'HK',
    name: 'Hong Kong',
  },
  {
    alpha3Code: 'MNG',
    alpha2Code: 'MN',
    name: 'Mongolia',
  },
  {
    alpha3Code: 'QAT',
    alpha2Code: 'QA',
    name: 'Qatar',
  },
  {
    alpha3Code: 'CUB',
    alpha2Code: 'CU',
    name: 'Cuba',
  },
  {
    alpha3Code: 'USA',
    alpha2Code: 'US',
    name: 'United States',
  },
  {
    alpha3Code: 'GIN',
    alpha2Code: 'GN',
    name: 'Guinea',
  },
  {
    alpha3Code: 'BHS',
    alpha2Code: 'BS',
    name: 'Bahamas',
  },
  {
    alpha3Code: 'COK',
    alpha2Code: 'CK',
    name: 'Cook Islands',
  },
  {
    alpha3Code: 'SVN',
    alpha2Code: 'SI',
    name: 'Slovenia',
  },
  {
    alpha3Code: 'MNP',
    alpha2Code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    alpha3Code: 'KOR',
    alpha2Code: 'KR',
    name: 'South Korea',
  },
  {
    alpha3Code: 'KOS',
    alpha2Code: 'XK',
    name: 'Kosovo',
  },
  {
    alpha3Code: 'CAN',
    alpha2Code: 'CA',
    name: 'Canada',
  },
  {
    alpha3Code: 'TKL',
    alpha2Code: 'TK',
    name: 'Tokelau',
  },
  {
    alpha3Code: 'GUM',
    alpha2Code: 'GU',
    name: 'Guam',
  },
  {
    alpha3Code: 'SSD',
    alpha2Code: 'SS',
    name: 'South Sudan',
  },
  {
    alpha3Code: 'SUR',
    alpha2Code: 'SR',
    name: 'Suriname',
  },
  {
    alpha3Code: 'HUN',
    alpha2Code: 'HU',
    name: 'Hungary',
  },
  {
    alpha3Code: 'DMA',
    alpha2Code: 'DM',
    name: 'Dominica',
  },
  {
    alpha3Code: 'NPL',
    alpha2Code: 'NP',
    name: 'Nepal',
  },
  {
    alpha3Code: 'GAB',
    alpha2Code: 'GA',
    name: 'Gabon',
  },
  {
    alpha3Code: 'BEL',
    alpha2Code: 'BE',
    name: 'Belgium',
  },
  {
    alpha3Code: 'LBR',
    alpha2Code: 'LR',
    name: 'Liberia',
  },
  {
    alpha3Code: 'UMI',
    alpha2Code: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    alpha3Code: 'BTN',
    alpha2Code: 'BT',
    name: 'Bhutan',
  },
  {
    alpha3Code: 'REU',
    alpha2Code: 'RE',
    name: 'Réunion',
  },
  {
    alpha3Code: 'SLE',
    alpha2Code: 'SL',
    name: 'Sierra Leone',
  },
  {
    alpha3Code: 'NLD',
    alpha2Code: 'NL',
    name: 'Netherlands',
  },
  {
    alpha3Code: 'BVT',
    alpha2Code: 'BV',
    name: 'Bouvet Island',
  },
  {
    alpha3Code: 'ERI',
    alpha2Code: 'ER',
    name: 'Eritrea',
  },
  {
    alpha3Code: 'MDV',
    alpha2Code: 'MV',
    name: 'Maldives',
  },
  {
    alpha3Code: 'LUX',
    alpha2Code: 'LU',
    name: 'Luxembourg',
  },
  {
    alpha3Code: 'NRU',
    alpha2Code: 'NR',
    name: 'Nauru',
  },
  {
    alpha3Code: 'SMR',
    alpha2Code: 'SM',
    name: 'San Marino',
  },
  {
    alpha3Code: 'HMD',
    alpha2Code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    alpha3Code: 'KNA',
    alpha2Code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    alpha3Code: 'CCK',
    alpha2Code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    alpha3Code: 'FLK',
    alpha2Code: 'FK',
    name: 'Falkland Islands',
  },
  {
    alpha3Code: 'VUT',
    alpha2Code: 'VU',
    name: 'Vanuatu',
  },
  {
    alpha3Code: 'CYP',
    alpha2Code: 'CY',
    name: 'Cyprus',
  },
  {
    alpha3Code: 'PSE',
    alpha2Code: 'PS',
    name: 'Palestine',
  },
  {
    alpha3Code: 'SRB',
    alpha2Code: 'RS',
    name: 'Serbia',
  },
  {
    alpha3Code: 'BDI',
    alpha2Code: 'BI',
    name: 'Burundi',
  },
  {
    alpha3Code: 'GRD',
    alpha2Code: 'GD',
    name: 'Grenada',
  },
  {
    alpha3Code: 'TUV',
    alpha2Code: 'TV',
    name: 'Tuvalu',
  },
  {
    alpha3Code: 'JEY',
    alpha2Code: 'JE',
    name: 'Jersey',
  },
  {
    alpha3Code: 'UZB',
    alpha2Code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    alpha3Code: 'KGZ',
    alpha2Code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    alpha3Code: 'POL',
    alpha2Code: 'PL',
    name: 'Poland',
  },
]
